export default __webpack_public_path__ + "static/media/Accepted.389de493.svg";